import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type * as API from '@trinity/chat/api/interfaces/projects';
import { useInvalidateProjectTagsQuery } from './useInvalidateTagsQuery';

type MutationParams = Omit<API.CreateProjectTag.Request, 'projectId'>;

export const useCreateTagMutation = (projectId: number) => {
  const invalidateTagsQuery = useInvalidateProjectTagsQuery(projectId);

  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: ['post:projects/tags', projectId],
    mutationFn: (data: MutationParams) => {
      return apiClient.projects.createProjectTag({
        projectId,
        ...data,
      });
    },
    onSuccess: (result) => {
      invalidateTagsQuery();
    },
  });
};
